angular.module('picmonic-common').directive('atlasHover', [
  function () {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        element.bind('mouseenter', function (event) {
          if (typeof atlasEvent !== 'undefined') {
            if (!attrs.atlasAction) {
              attrs.atlasAction = 'click';
            }

            atlasEvent(attrs.atlasAction, attrs.atlasHover);
          }
        });
      },
    };
  },
]);
